import useLoginCheck from 'hooks/common/useLoginCheck';
import { deletePlace } from 'lib/api/place';
import { useMutation, useQueryClient } from 'react-query';

const useContractViewerPlaceCard = id => {
  const queryClient = useQueryClient();

  const { isLoading, error, mutate, reset } = useMutation(deletePlace, {
    onSuccess: () => {
      queryClient.invalidateQueries('contract');
      queryClient.invalidateQueries('dashboardCounts');
    },
  });
  useLoginCheck(error?.response, () => {
    mutate(id);
  });

  const onDelete = () => {
    mutate(id);
  };

  return { isLoading, error, reset, onDelete };
};

export default useContractViewerPlaceCard;
